module.exports = __webpack_public_path__ + "img/logo-black-with-text.aa75538.svg";